export const PlanType = {
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL'
}
